<template>
  <div class="i18n-dropdown">
    <div class="i18n-btn">国际化</div>
    <div class="dropdown-list">
      <div
        class="dropdown-item"
        v-for="language in $languages"
        :key="language.value"
        @click="changeLocale(language.value)"
      >{{ language.label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    changeLocale(command) {
      this.$i18n.locale = command;
      let message = `当前语言：${this.$t("_name")} [ ${this.$i18n.locale} ]`;
      //   console.log("语言变更", message);
    }
  }
};
</script>

<style lang="scss" scoped>
.i18n-dropdown {
  position: relative;
  display: inline-block;

  .i18n-btn {
    color: #fff;
    font-weight: bold;
    cursor: pointer;
  }
  .dropdown-list {
    display: none;
    position: absolute;
    z-index: 100;
    top: 100%;
    right: 0;
    min-width: 80px;
    background-color: #fff;
    border-radius: 4px;
  }
  .dropdown-item {
    padding: 4px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  &:hover {
    .dropdown-list {
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/common/components/i18n-btn/index.vue